import SideBarHeader from './SideBarHeader';
import SideBarMenu from './SideBarMenu';

const Sidebar = () => {
  return (
    <div
      className="sidebar bg-white border-r border-r-gray-F1F0F3 fixed top-0 bottom-0 z-20 hidden lg:flex flex-col items-stretch shrink-0 dark-mode:bg-coal-600 dark-mode:border-r-coal-100"
      data-drawer="true"
      data-drawer-class="drawer drawer-start top-0 bottom-0"
      data-drawer-enable="true|lg:false"
      id="sidebar"
    >
      <SideBarHeader />
      <SideBarMenu />
    </div>
  );
};

export default Sidebar;
